var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSlimGradientGift = function SvgIconSlimGradientGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4.772,
    width: 15.06,
    height: 4.695,
    rx: 1,
    stroke: "url(#icon-slim-gradient-gift_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.165 9.467v6.594c0 .519-.42.939-.94.939h-9.38a.939.939 0 0 1-.94-.939V9.467",
    stroke: "url(#icon-slim-gradient-gift_svg__b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.535 4.772V17",
    stroke: "url(#icon-slim-gradient-gift_svg__c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.535 4.772S8.612 1 4.907 1c-.858 0-2.001.525-1.822 1.955.18 1.43 2.064 1.817 2.064 1.817",
    stroke: "url(#icon-slim-gradient-gift_svg__d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.537 4.772S8.46 1 12.166 1c.857 0 2 .525 1.821 1.955-.18 1.43-2.063 1.817-2.063 1.817",
    stroke: "url(#icon-slim-gradient-gift_svg__e)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-slim-gradient-gift_svg__a",
    x1: 1,
    y1: 4.772,
    x2: 3.668,
    y2: 13.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F86EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C4CB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-slim-gradient-gift_svg__b",
    x1: 2.906,
    y1: 9.467,
    x2: 9.869,
    y2: 19.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F86EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C4CB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-slim-gradient-gift_svg__c",
    x1: 8.066,
    y1: 4.772,
    x2: 9.933,
    y2: 4.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F86EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C4CB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-slim-gradient-gift_svg__d",
    x1: 3.066,
    y1: 1,
    x2: 6.592,
    y2: 6.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F86EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C4CB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-slim-gradient-gift_svg__e",
    x1: 14.006,
    y1: 1,
    x2: 10.48,
    y2: 6.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F86EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C4CB0"
  })))));
};
export { SvgIconSlimGradientGift as ReactComponent };
export default "data:image/svg+xml;base64,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";